<template>
<div>
  <div class="menu--relative">
    <div class="menu--fixed hidden">
      <div class="menu--container">
        <div class="menu--container__logo animation-left">
          <img src="@/assets/img/logos/logo.svg" width="137" class="logo" alt="Minds">
        </div>
        <div class="menu--container__links">
          <ul class="animation-top">
            <li>
              <!-- <router-link :to="{ name: 'home' }">INÍCIO</router-link> -->
            </li>
            <li>
              <!-- <router-link :to="{ name: 'books' }">BOOKS</router-link> -->
            </li>
            <li>
              <!-- <router-link :to="{ name: 'lojinha' }">LOJINHA</router-link> -->
            </li>
            <li>
              <!-- <router-link :to="{ name: 'palavras' }">PALAVRAS</router-link> -->
            </li>
          </ul>
        </div>
        <div class="menu--container__icons">
          <ul class="animation-top">
            <li>
              <!-- <router-link :to="{ name: 'home' }"><i class="fa fa-home" aria-hidden="true"></i></router-link> -->
            </li>
            <li>
              <!-- <router-link :to="{ name: 'books' }"><i class="fa fa-book" aria-hidden="true"></i></router-link> -->
            </li>
            <li>
              <!-- <router-link :to="{ name: 'lojinha' }"><i class="fa fa-gift" aria-hidden="true"></i></router-link> -->
            </li>
            <li>
              <!-- <router-link :to="{ name: 'palavras' }"><i class="fa fa-font" aria-hidden="true"></i></router-link> -->
            </li>
          </ul>
        </div>
        <div class="menu--container__user">
          <userContent class="animation-right " :data="teacher"/>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import userContent from './userContent'

export default {
  name: 'teacherHeader',
  components: {
    userContent
  },
  computed: {
    teacher () {
      return this.$store.getters['teacher/get']
    }
  }
}
</script>

<style scoped lang="scss">
.menu--relative {
    position: relative;
    width: 100%;
    min-height: 100px;
    margin-bottom: 20px;
    z-index: 125;
    .menu--fixed {
        background-image: linear-gradient(-180deg, #C50737 60%, #CD1F26);
        box-shadow: 0 0 55px 0 rgba(0,0,0,.5);
        position: fixed;
        top: 0;
        left: 0;
        box-sizing: border-box;
        width: 100%;
        z-index: 100;
        .menu--container {
            color: #FF9AA6;
            a,
            router-link {
                color: #FF9AA6;
                transition: 0.1s;
                font-size: 14px;
                &:hover {
                    color: #fff;
                }
            }
            min-height: 100px;
            width: 980px;
            max-width: 90%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .menu--container__logo {
                .logo {
                    max-width: 100%;
                    min-width: 80px;
                }
            }
            .menu--container__links {
                transition: 0.3s;
                ul {
                    list-style: none;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: center;
                    li {
                        a,
                        router-link {
                            background: #ffffff;
                            color: #C2003C;
                            padding: 10px 35px;
                            border-radius: 50px;
                            margin: 10px;
                            line-height: 35px;
                            height: 35px;
                            font-size: 14px;
                            font-weight: 900;
                            transition: 0.1s;
                            &:hover {
                                color: #fff;
                                background: #FBC024;
                            }
                        }
                    }
                }
            }
            .menu--container__icons {
                display: none;
                ul {
                    list-style: none;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    li {
                        a,
                        router-link {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background: #ffffff;
                            color: #C2003C;
                            padding: 10px;
                            border-radius: 50px;
                            margin: 5px;
                            line-height: 35px;
                            height: 35px;
                            transition: 0.1s;
                            &:hover {
                                color: #fff;
                                background: #FBC024;
                            }
                        }
                        .fa {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}

.example {
    background: #00ACC2;
    border-radius: 4px;
    padding-top: 0;
}
@media screen and (max-width: 1200px) {
    .menu--container__links {
        display: none;
    }
    .menu--container__icons {
        display: block!important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header/teacher.vue